import { toast } from 'react-toastify';

export const toastContainerProps = {
    autoClose: 5000,
    closeOnClick: false,
    draggable: true,
    hideProgressBar: false,
    newestOnTop: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    position: 'bottom-right',
    rtl: false,
};

export const toastProps = {};

export function fetchingToast(message, propOverrides = {}) {
    return toast.info(message, {
        autoClose: false,
        hideProgressBar: true,
        ...toastProps,
        ...propOverrides,
    });
}

export function infoToast(message, propOverrides = {}) {
    return toast.info(message, { ...toastProps, ...propOverrides });
}

export function errorToast(message, propOverrides = {}) {
    return toast.error(message, {
        autoClose: false,
        ...toastProps,
        ...propOverrides,
    });
}

export function warningToast(message, propOverrides = {}) {
    return toast.warn(message, { ...toastProps, ...propOverrides });
}

export function successToast(message, propOverrides = {}) {
    return toast.success(message, { ...toastProps, ...propOverrides });
}
